import { RecruitmentStatus } from "~/api/_common/types-for-recruitment"

import { Company, CreateCompanyArgs } from "./Company"

export interface createMagazineArgs {
  id: number
  title: string
  content: string
  thumbnail_img_url: string
  status: RecruitmentStatus
  url: string
  company: CreateCompanyArgs
}

export class Magazine {
  id: number
  title: string
  content: string
  thumbnailImgUrl: string
  status: RecruitmentStatus
  url: string
  company: Company

  constructor(args: createMagazineArgs) {
    this.id = args.id
    this.title = args.title
    this.content = args.content
    this.thumbnailImgUrl = args.thumbnail_img_url
    this.status = args.status
    this.url = args.url || ""
    this.company = new Company(args.company)
  }
}
